import React, { useState } from 'react';
import { Dialog, DialogContent, TextField, Button, Typography, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import './ForgotPasswordStyles.css';

export default function ResetPassword({ open, onClose, onSubmit }) {
    const [passwords, setPasswords] = useState({ password: '', confirmPassword: '' });
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (passwords.password !== passwords.confirmPassword) {
            setError('Passwords do not match');
            return;
        }
        try {
            await onSubmit(passwords.password);
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <Dialog 
            open={open} 
            onClose={onClose} 
            maxWidth="sm" 
            fullWidth
            PaperProps={{
                sx: {
                    width: '100%',
                    maxWidth: '444px', // Match sign in dialog width
                    margin: '20px'
                }
            }}
        >
            <DialogContent className="forgot-password-dialog">
                <Typography className="forgot-password-title">
                    Create New Password
                </Typography>
                <Typography className="forgot-password-subtitle">
                    Enter your new password below
                </Typography>
                <form onSubmit={handleSubmit}>
                    <TextField
                        className="forgot-password-input"
                        label="New Password"
                        type={showPassword ? 'text' : 'password'}
                        value={passwords.password}
                        onChange={(e) => setPasswords({ ...passwords, password: e.target.value })}
                        required
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                    <TextField
                        className="forgot-password-input"
                        label="Confirm Password"
                        type={showPassword ? 'text' : 'password'}
                        value={passwords.confirmPassword}
                        onChange={(e) => setPasswords({ ...passwords, confirmPassword: e.target.value })}
                        error={!!error}
                        helperText={error}
                        required
                    />
                    <Button
                        type="submit"
                        className="forgot-password-button"
                    >
                        Reset Password
                    </Button>
                </form>
            </DialogContent>
        </Dialog>
    );
} 